import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import statesStore, { persistor } from "./states";
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter, RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import './styles/components.module.css';
import './styles/top_loader.scss';
import './styles/index.css';
import './styles/tailwind.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import Loader from './components/Loader';
import router from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={statesStore}>
      <PersistGate loading={null} persistor={persistor} >
        <QueryClientProvider client={queryClient}>
          <Suspense fallback={<Loader message='Loading app...' />} >
            <RouterProvider router={router} />

            <ToastContainer
              autoClose={600}
              closeButton
              position="top-right"
            />
          </Suspense>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

